import React from 'react';
import { Wrapper, ComponentWrapper, EmptyScreen } from './styles';
export function Unauthorized() {
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ComponentWrapper, null, /*#__PURE__*/React.createElement(EmptyScreen, {
    title: 'Unauthorized',
    description: 'You do not have access to this page'
  })));
}
export default Unauthorized;